import React from 'react';

interface PlannerIconProps {
  className?: string;
}

const PlannerIcon: React.FC<PlannerIconProps> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
    >
      <path d="m10.146 9.146 2.146-2.146h-3.293v-1h3.5c.827 0 1.5.673 1.5 1.5v3.5h-1v-3.293l-2.146 2.146c-.274.275-.555.55-.836.826-2.467 2.423-5.018 4.929-5.018 8.321h-1c0-3.812 2.703-6.467 5.317-9.034.278-.274.557-.547.829-.819zm3.1 4.9-1.746 1.747-1.746-1.747-.707.707 1.746 1.747-1.746 1.747.707.707 1.746-1.747 1.746 1.747.707-.707-1.746-1.747 1.746-1.747zm-10.246-5.046c0-1.103.897-2 2-2s2 .897 2 2-.897 2-2 2-2-.897-2-2zm1 0c0 .551.448 1 1 1s1-.449 1-1-.448-1-1-1-1 .449-1 1zm11-7h2v19.5c0 1.378-1.121 2.5-2.5 2.5h-12c-1.379 0-2.5-1.122-2.5-2.5v-19.5h2v-2h1v2h2v-2h1v2h2v-2h1v2h2v-2h1v2h2v-2h1zm1 1h-15v18.5c0 .827.673 1.5 1.5 1.5h12c.827 0 1.5-.673 1.5-1.5zm8-.5v18.989l-2.5 2.5-2.5-2.5v-18.989c0-1.378 1.121-2.5 2.5-2.5s2.5 1.122 2.5 2.5zm-1 0c0-.827-.673-1.5-1.5-1.5s-1.5.673-1.5 1.5v18.575l1.5 1.5 1.5-1.5z"/>
    </svg>
  );
};

export default PlannerIcon;
